import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useApolloClient } from '@apollo/react-hooks';
import { LIST_SUM_ASSURED_RANGE_OF_PRODUCT } from '../graphql';
import { useCallback, useState } from 'react';
import { useDeepCompareEffect } from 'react-use';
import { DEFAULT_RANGE } from '../constants/product';
export const getAssuredRange = (age, ranges) => (ranges === null || ranges === void 0 ? void 0 : ranges.find(({
  max_issue_age,
  min_issue_age
}) => max_issue_age >= age && min_issue_age <= age)) || DEFAULT_RANGE;

const useProductSumAssuredRangeMapping = (productCodes, age) => {
  const client = useApolloClient();
  const [map, setMap] = useState(new Map());
  const setSumAssuredMap = useCallback(function () {
    var _ref = _asyncToGenerator(function* (productCodes, age) {
      const results = yield Promise.all(productCodes.map(function () {
        var _ref2 = _asyncToGenerator(function* (productCode) {
          try {
            const {
              data
            } = yield client.query({
              query: LIST_SUM_ASSURED_RANGE_OF_PRODUCT,
              variables: {
                product_id: productCode
              }
            });

            if (data && data.sumAssuredRanges) {
              return [productCode, getAssuredRange(age, data.sumAssuredRanges)];
            }

            return [productCode, DEFAULT_RANGE];
          } catch {
            return [productCode, DEFAULT_RANGE];
          }
        });

        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }()));
      setMap(new Map(results));
    });

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [client]);
  useDeepCompareEffect(() => {
    setSumAssuredMap(productCodes, age);
  }, [age, productCodes, setSumAssuredMap]);
  return [map];
};

export default useProductSumAssuredRangeMapping;